import request from '@/plugin/axios'

export function AccountLogin (data) {
  return request({
    url: '/v1/quan_xian/deng_lu/login',
    method: 'post',
    data
  })
}
// 过期提醒

export function Expire (params) {
  return request({
    url: '/v1/quan_xian/deng_lu/isExpire',
    method: 'get',
    params
  })
}
